import apiClient from './apiClient'

/**
 * Fetch downloads
 * @returns Collection with countries
 */
export const getWebDownloads = async () => await apiClient.get('/api/WebDownloads')